'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var webfontloader = require('webfontloader');
var PropTypes = _interopDefault(require('prop-types'));
var toCSS = _interopDefault(require('style-to-css'));
var uniqueId = _interopDefault(require('mini-unique-id'));

var _jsxFileName = '/Users/buckleyn/Projects/panels/blocks/dangerously-set-inner-html.js';
var _this = undefined;
var DangerouslySetInnerHTML = function DangerouslySetInnerHTML(props) {
  return React__default.createElement('div', {
    dangerouslySetInnerHTML: {
      __html: props.html
    },
    'data-block': props['data-block'],
    ref: props._ref,
    style: props.style,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: _this
  });
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var loaded = [];

var Font = function (_React$Component) {
  inherits(Font, _React$Component);

  function Font() {
    classCallCheck(this, Font);
    return possibleConstructorReturn(this, (Font.__proto__ || Object.getPrototypeOf(Font)).apply(this, arguments));
  }

  createClass(Font, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.load();
    }
  }, {
    key: 'load',
    value: function load() {
      var props = this.props;


      var family = props.family;
      var source = props.source;

      var urls = void 0;
      if (props.family === 'FontAwesome') {
        source = 'custom';
        urls = ['https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css'];
      } else if (typeof props.weight === 'string') {
        family = family + ':' + props.weight;
      }

      if (loaded.includes(family)) return;
      loaded.push(family);

      webfontloader.load(defineProperty({}, source, {
        families: [family],
        urls: urls
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Font;
}(React__default.Component);

Font.defaultProps = {
  source: 'google'
};

// original src: https://github.com/substack/path-browserify
function normaliseArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// original src: https://github.com/substack/path-browserify
function normalisePath(rawPath) {
  var isAbsolute = rawPath.charAt(0) === '/';
  var trailingSlash = rawPath.substr(-1) === '/';

  // normalise the path
  var path = normaliseArray(rawPath.split('/').filter(function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
}

var TRAILING_SLASH_REGEX = /\/$/;

function withTrailingSlash(uri) {
  return TRAILING_SLASH_REGEX.test(uri) ? uri : uri + "/";
}

var decodeSchema = function decodeSchema(s) {
  return s.replace(/<<HTTP>>/g, 'http://').replace(/<<HTTPS>>/g, 'https://');
};
var encodeSchema = function encodeSchema(s) {
  return s.replace(/http:\/\//g, '<<HTTP>>').replace(/https:\/\//g, '<<HTTPS>>');
};

var normaliseUri = (function (uri) {
  return decodeSchema(normalisePath(withTrailingSlash(encodeSchema(uri))));
});

var _jsxFileName$2 = '/Users/buckleyn/Projects/panels/blocks/teleport.js';
var Teleport = function (_React$Component) {
  inherits(Teleport, _React$Component);

  function Teleport(props, context) {
    classCallCheck(this, Teleport);

    var _this = possibleConstructorReturn(this, (Teleport.__proto__ || Object.getPrototypeOf(Teleport)).call(this, props, context));

    _this.className = 'Teleport-' + uniqueId();
    return _this;
  }

  createClass(Teleport, [{
    key: 'render',
    value: function render() {
      var className = this.className;
      var _props = this.props,
          context = _props.context,
          children = _props.children,
          focus = _props.focus,
          loose = _props.loose,
          onClick = _props.onClick,
          _ref = _props._ref,
          style = _props.style,
          styleActive = _props.styleActive,
          styleActiveHover = _props.styleActiveHover,
          styleHover = _props.styleHover,
          title = _props.title,
          to = _props.to,
          rest = objectWithoutProperties(_props, ['context', 'children', 'focus', 'loose', 'onClick', '_ref', 'style', 'styleActive', 'styleActiveHover', 'styleHover', 'title', 'to']);
      var _context = this.context,
          isActive = _context.isActive,
          navigate = _context.navigate,
          route = _context.route;

      var active = isActive(to, loose);
      var href = normaliseUri('' + route.context + to);

      var inlineStyle = '';
      if (!active && styleHover) {
        inlineStyle = '.' + className + ':hover {' + toCSS(styleHover) + '}';
      }
      if (active && styleActiveHover) {
        inlineStyle = '.' + className + ':hover {' + toCSS(styleActiveHover) + '}';
      }
      var finalStyle = active ? _extends({}, style, styleActive) : style;

      var finalOnClick = function finalOnClick(event) {
        event.preventDefault();
        var preventNavigate = false;

        if (typeof onClick === 'function') {
          preventNavigate = onClick(event);
        }

        if (preventNavigate !== true) {
          navigate(to, focus, context);
        }
      };

      if (_ref) {
        rest.ref = _ref;
      }

      return React__default.createElement(
        'a',
        _extends({}, rest, {
          className: className,
          href: href,
          onClick: finalOnClick,
          style: finalStyle,
          title: title,
          __source: {
            fileName: _jsxFileName$2,
            lineNumber: 61
          },
          __self: this
        }),
        React__default.createElement(
          'style',
          {
            __source: {
              fileName: _jsxFileName$2,
              lineNumber: 69
            },
            __self: this
          },
          inlineStyle
        ),
        children
      );
    }
  }]);
  return Teleport;
}(React__default.Component);

Teleport.contextTypes = {
  isActive: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  route: PropTypes.shape({
    context: PropTypes.string.isRequired
  }).isRequired
};

var _jsxFileName$3 = '/Users/buckleyn/Projects/panels/blocks/go-to.js';
var GoTo = function (_React$Component) {
  inherits(GoTo, _React$Component);

  function GoTo() {
    classCallCheck(this, GoTo);
    return possibleConstructorReturn(this, (GoTo.__proto__ || Object.getPrototypeOf(GoTo)).apply(this, arguments));
  }

  createClass(GoTo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          _ref = _props._ref,
          styleActive = _props.styleActive,
          styleHover = _props.styleHover,
          props = objectWithoutProperties(_props, ['children', 'className', '_ref', 'styleActive', 'styleHover']);


      var inlineStyle = null;
      if (Object.keys(styleHover).length) {
        inlineStyle = React__default.createElement(
          'style',
          {
            __source: {
              fileName: _jsxFileName$3,
              lineNumber: 19
            },
            __self: this
          },
          '.' + className + ':hover {' + toCSS(styleHover) + '}'
        );
      }

      if (_ref) {
        props.ref = _ref;
      }

      return React__default.createElement(
        'a',
        _extends({}, props, { className: className, target: '_blank', __source: {
            fileName: _jsxFileName$3,
            lineNumber: 28
          },
          __self: this
        }),
        inlineStyle,
        children
      );
    }
  }]);
  return GoTo;
}(React__default.Component);

var _jsxFileName$4 = '/Users/buckleyn/Projects/panels/blocks/on-click.js';
var OnClick = function (_React$Component) {
  inherits(OnClick, _React$Component);

  function OnClick() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, OnClick);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = OnClick.__proto__ || Object.getPrototypeOf(OnClick)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(OnClick, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;


      var manualActive = typeof props.isActive === 'boolean';
      this.setState({
        isActive: manualActive ? props.isActive : false,
        manualActive: manualActive
      });

      this.bindOnClick(props.onClick);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.bindOnClick(nextProps.onClick);

      var manualActive = typeof nextProps.isActive === 'boolean';

      if (manualActive) {
        this.setState({
          isActive: nextProps.isActive,
          manualActive: manualActive
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onClickTimeout) {
        clearTimeout(this.onClickTimeout);
      }
    }
  }, {
    key: 'bindOnClick',
    value: function bindOnClick(onClick) {
      var _this2 = this;

      var context = this.context;

      /* eslint-disable no-console */

      var finalOnClick = void 0;
      if (typeof onClick === 'function') {
        finalOnClick = function finalOnClick() {
          try {
            onClick();
          } catch (err) {
            var match = err.message.match(/props\.(.+) is not a function/);
            if (match) {
              context.transitionTo(match[1].trim(), true);
            }
          }
        };
      } else {
        var match = void 0;
        if (typeof onClick === 'string') {
          match = onClick.match(/transitionTo\((.+)\)/);
        }
        if (match && typeof context.transitionTo === 'function') {
          finalOnClick = function finalOnClick() {
            return context.transitionTo(match[1].trim());
          };
        } else {
          finalOnClick = function finalOnClick() {
            return console.log(onClick);
          };
        }
      }

      this.onClick = function (event) {
        finalOnClick(event);

        event.stopPropagation();

        if (!_this2.state.manualActive) {
          _this2.setState({
            isActive: true
          });

          _this2.onClickTimeout = setTimeout(function () {
            _this2.setState({
              isActive: false
            });
            _this2.onClickTimeout = null;
          }, _this2.props.styleActiveTimeout);
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context;
      var isActive = this.state.isActive;
      /* eslint-disable no-unused-vars */

      var _props = this.props,
          ariaLabel = _props['aria-label'],
          children = _props.children,
          className = _props.className,
          _isActive = _props.isActive,
          isDisabled = _props.isDisabled,
          _ref = _props._ref,
          style = _props.style,
          styleActive = _props.styleActive,
          styleActiveHover = _props.styleActiveHover,
          styleActiveTimeout = _props.styleActiveTimeout,
          styleDisabled = _props.styleDisabled,
          styleHover = _props.styleHover,
          rest = objectWithoutProperties(_props, ['aria-label', 'children', 'className', 'isActive', 'isDisabled', '_ref', 'style', 'styleActive', 'styleActiveHover', 'styleActiveTimeout', 'styleDisabled', 'styleHover']);


      var inlineStyle = null;
      if (!isDisabled) {
        rest.onClick = this.onClick;

        var fClass = className.split(' ')[0];
        if (!isActive && styleHover) {
          inlineStyle = React__default.createElement(
            'style',
            {
              __source: {
                fileName: _jsxFileName$4,
                lineNumber: 114
              },
              __self: this
            },
            '.' + fClass + ':hover {' + toCSS(styleHover) + '}'
          );
        }
        if (isActive && styleActiveHover) {
          inlineStyle = React__default.createElement(
            'style',
            {
              __source: {
                fileName: _jsxFileName$4,
                lineNumber: 119
              },
              __self: this
            },
            '.' + fClass + ':hover {' + toCSS(styleActiveHover) + '}'
          );
        }
      }

      var finalStyle = _extends({
        cursor: 'pointer'
      }, style);
      if (isDisabled) {
        finalStyle = _extends({}, finalStyle, {
          cursor: 'default'
        }, styleDisabled);
      } else if (isActive) {
        finalStyle = _extends({}, finalStyle, styleActive);
      }

      if (_ref) {
        rest.ref = _ref;
      }

      return React__default.createElement(
        'button',
        _extends({}, rest, {
          'aria-label': ariaLabel ? context.i18n ? context.i18n.t(ariaLabel) : ariaLabel : undefined,
          className: className,
          style: finalStyle, __source: {
            fileName: _jsxFileName$4,
            lineNumber: 146
          },
          __self: this
        }),
        inlineStyle,
        children
      );
    }
  }]);
  return OnClick;
}(React__default.Component);

OnClick.contextTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  }),
  transitionTo: PropTypes.func
};
OnClick.defaultProps = {
  styleActiveTimeout: 1000
};

var _jsxFileName$1 = '/Users/buckleyn/Projects/panels/blocks/create-group.js';
function createGroup(name, groupStyle) {
  var Group = function (_React$Component) {
    inherits(Group, _React$Component);

    function Group(props, context) {
      classCallCheck(this, Group);

      var _this = possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props, context));

      _this.localClassName = name + '-' + uniqueId();
      return _this;
    }

    createClass(Group, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            moreClassName = _props.className,
            goTo = _props.goTo,
            style = _props.style,
            teleportTo = _props.teleportTo,
            props = objectWithoutProperties(_props, ['children', 'className', 'goTo', 'style', 'teleportTo']);
        var localClassName = this.localClassName;
        var pages = this.context.pages;


        var finalStyle = _extends({}, groupStyle, style);

        var className = localClassName;
        if (typeof moreClassName === 'string') {
          className += ' ' + moreClassName;
        }

        var Base = void 0;
        if (teleportTo) {
          Base = Teleport;
          props.to = teleportTo;
        } else if (goTo) {
          Base = GoTo;
          props.href = goTo;
        } else if ((props.onClick || props.onMouseDown || props.onMouseUp) && !props.noButton) {
          Base = OnClick;
        } else {
          var isDisabled = props.isDisabled,
              noButton = props.noButton,
              _ref = props._ref,
              styleDisabled = props.styleDisabled,
              styleActive = props.styleActive,
              styleActiveHover = props.styleActiveHover,
              styleActiveTimeout = props.styleActiveTimeout,
              styleHover = props.styleHover,
              rest = objectWithoutProperties(props, ['isDisabled', 'noButton', '_ref', 'styleDisabled', 'styleActive', 'styleActiveHover', 'styleActiveTimeout', 'styleHover']);


          var inlineStyle = null;
          if (isDisabled) {
            if (styleDisabled) {
              finalStyle = _extends({}, finalStyle, styleDisabled);
            }
          } else {
            if (Object.keys(styleHover).length) {
              inlineStyle = React__default.createElement(
                'style',
                {
                  __source: {
                    fileName: _jsxFileName$1,
                    lineNumber: 75
                  },
                  __self: this
                },
                '.' + localClassName + ':hover {' + toCSS(styleHover) + '}'
              );
            }
          }

          return React__default.createElement(
            'div',
            _extends({}, rest, { className: className, ref: _ref, style: finalStyle, __source: {
                fileName: _jsxFileName$1,
                lineNumber: 81
              },
              __self: this
            }),
            inlineStyle,
            children
          );
        }

        if (pages && pages.isSelecting) {
          props.onClick = function (event) {
            if (event) {
              event.preventDefault();
            }
            return true;
          };
        }

        return React__default.createElement(
          Base,
          _extends({}, props, { className: className, style: finalStyle, __source: {
              fileName: _jsxFileName$1,
              lineNumber: 98
            },
            __self: this
          }),
          children
        );
      }
    }]);
    return Group;
  }(React__default.Component);

  Group.contextTypes = {
    pages: PropTypes.shape({
      isSelecting: PropTypes.bool
    })
  };

  Group.defaultProps = {
    className: '',
    style: {},
    styleActive: {},
    styleHover: {}
  };

  Group.displayName = name;

  return Group;
}

var Horizontal = createGroup('Horizontal', { flexDirection: 'row' });

var _jsxFileName$6 = '/Users/buckleyn/Projects/panels/blocks/knocking.js';
var _this$1 = undefined;
var animation = '@keyframes scaleout {\n  0% {\n    transform: scale(0.0);\n    -webkit-transform: scale(0.0);\n  } 100% {\n    transform: scale(1.0);\n    -webkit-transform: scale(1.0);\n    opacity: 0;\n  }\n}';

var Knocking = function Knocking(_ref) {
  var dataBlock = _ref['data-block'],
      size = _ref.size,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  var finalStyle = _extends({
    animation: 'scaleout 1.0s infinite linear',
    backgroundColor: style.color,
    borderRadius: size,
    height: size,
    WebkitAnimation: 'scaleout 1.0s infinite linear',
    width: size
  }, style);

  return React__default.createElement(
    Horizontal,
    { 'data-block': dataBlock, style: finalStyle, __source: {
        fileName: _jsxFileName$6,
        lineNumber: 27
      },
      __self: _this$1
    },
    React__default.createElement(
      'style',
      {
        __source: {
          fileName: _jsxFileName$6,
          lineNumber: 28
        },
        __self: _this$1
      },
      animation
    )
  );
};

Knocking.defaultProps = {
  style: {
    color: '#323232'
  },
  size: 32
};

var _jsxFileName$5 = '/Users/buckleyn/Projects/panels/blocks/image.js';
var Image = function (_React$Component) {
  inherits(Image, _React$Component);

  function Image(props) {
    classCallCheck(this, Image);

    var _this = possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.onLoad = _this.onLoad.bind(_this);
    _this.state = {
      isLoading: true
    };
    return _this;
  }

  createClass(Image, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.src !== nextProps.src) {
        this.setState({
          isLoading: true
        });
      }
    }
  }, {
    key: 'onLoad',
    value: function onLoad() {
      this.setState({
        isLoading: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.state.isLoading;
      var _props = this.props,
          text = _props.text,
          src = _props.src,
          style = _props.style,
          styleLoading = _props.styleLoading,
          styleWrapper = _props.styleWrapper;


      return React__default.createElement(
        'div',
        { style: styleWrapper, __source: {
            fileName: _jsxFileName$5,
            lineNumber: 32
          },
          __self: this
        },
        isLoading && React__default.createElement(Knocking, { style: styleLoading, __source: {
            fileName: _jsxFileName$5,
            lineNumber: 33
          },
          __self: this
        }),
        React__default.createElement('img', {
          alt: text,
          onLoad: this.onLoad,
          src: src,
          style: style,
          title: text,
          __source: {
            fileName: _jsxFileName$5,
            lineNumber: 34
          },
          __self: this
        })
      );
    }
  }]);
  return Image;
}(React__default.Component);

Image.defaultProps = {
  src: 'https://files.usepages.today/usepages.today/image-placeholder.svg',
  style: {},
  styleLoading: {
    position: 'absolute'
  },
  styleWrapper: {},
  text: 'Alternative text'
};

var _jsxFileName$7 = '/Users/buckleyn/Projects/panels/blocks/input.js';
var PLACEHOLDER_PREFIXES = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-ms-input-placeholder', ':placeholder-shown'];

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input(props) {
    classCallCheck(this, Input);

    var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.id = 'Input-' + uniqueId();
    return _this;
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var context = this.context,
          id = this.id;
      var _props = this.props,
          disabled = _props.disabled,
          onEnter = _props.onEnter,
          placeholder = _props.placeholder,
          _ref = _props._ref,
          style = _props.style,
          styleDisabled = _props.styleDisabled,
          styleFocus = _props.styleFocus,
          styleHover = _props.styleHover,
          stylePlaceholder = _props.stylePlaceholder,
          styleWrapper = _props.styleWrapper,
          rest = objectWithoutProperties(_props, ['disabled', 'onEnter', 'placeholder', '_ref', 'style', 'styleDisabled', 'styleFocus', 'styleHover', 'stylePlaceholder', 'styleWrapper']);


      var finalStyle = style;

      var backgroundColor = style && style.backgroundColor || 'transparent';
      var color = style && style.color || 'black';
      var inlineStyle = ['#' + id + ':-webkit-autofill {\n      background-color: ' + backgroundColor + ' !important;\n      box-shadow: 0 0 0px 1000px ' + backgroundColor + ' inset;\n      color: ' + color + ' !important;\n    }'];

      if (stylePlaceholder) {
        PLACEHOLDER_PREFIXES.forEach(function (prefix) {
          inlineStyle.push('#' + id + prefix + ' {' + toCSS(stylePlaceholder) + '}');
        });
      }

      if (styleDisabled && disabled) {
        finalStyle = _extends({}, style, styleDisabled);
      } else {
        if (styleHover) {
          inlineStyle.push(inlineStyle + ' #' + id + ':hover {' + toCSS(styleHover) + '}');
        }
        if (styleFocus) {
          inlineStyle.push('#' + id + ':focus {' + toCSS(styleFocus) + '}');
        }
      }

      var onKeyUp = void 0;
      if (typeof onEnter !== 'undefined') {
        /* eslint-disable no-console */
        var finalOnEnter = typeof onEnter === 'function' ? onEnter : function () {
          return console.log(onEnter);
        };
        onKeyUp = function onKeyUp(event) {
          return event.key === 'Enter' && finalOnEnter(event);
        };
      }

      return React__default.createElement(
        'div',
        { style: styleWrapper, __source: {
            fileName: _jsxFileName$7,
            lineNumber: 76
          },
          __self: this
        },
        React__default.createElement(
          'style',
          {
            __source: {
              fileName: _jsxFileName$7,
              lineNumber: 77
            },
            __self: this
          },
          inlineStyle.join('\n')
        ),
        React__default.createElement('input', _extends({}, rest, {
          autoComplete: 'off',
          id: id,
          onKeyUp: onKeyUp,
          ref: _ref,
          placeholder: placeholder ? context.i18n ? context.i18n.t(placeholder) : placeholder : undefined,
          style: finalStyle,
          __source: {
            fileName: _jsxFileName$7,
            lineNumber: 78
          },
          __self: this
        }))
      );
    }
  }]);
  return Input;
}(React__default.Component);

Input.defaultProps = {
  placeholder: '',
  style: {},
  styleHover: {},
  styleWrapper: {},
  type: 'text'
};

Input.contextTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  })
};

var List = function List() {
  return null;
};

var _jsxFileName$8 = '/Users/buckleyn/Projects/panels/blocks/style.js';
var _this$2 = undefined;
var Style = function Style(props) {
  return React__default.createElement(
    'style',
    {
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 4
      },
      __self: _this$2
    },
    props.css
  );
};

var _jsxFileName$9 = '/Users/buckleyn/Projects/panels/blocks/text.js';
var _this$3 = undefined;
var Text = function Text(_ref, context) {
  var style = _ref.style,
      text = _ref.text,
      props = objectWithoutProperties(_ref, ['style', 'text']);

  var finalStyle = _extends({
    whiteSpace: 'pre-line'
  }, style);
  return React__default.createElement(
    'div',
    _extends({}, props, { style: finalStyle, __source: {
        fileName: _jsxFileName$9,
        lineNumber: 10
      },
      __self: _this$3
    }),
    context.i18n ? context.i18n.t(text) : text
  );
};
Text.contextTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  })
};

Text.defaultProps = {
  style: {},
  text: ''
};

var _jsxFileName$10 = '/Users/buckleyn/Projects/panels/blocks/textarea.js';
var PLACEHOLDER_PREFIXES$1 = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-ms-input-placeholder', ':placeholder-shown'];

var Textarea = function (_Component) {
  inherits(Textarea, _Component);

  function Textarea() {
    var _ref2;

    classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, (_ref2 = Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call.apply(_ref2, [this].concat(args)));

    _this.id = 'Textarea-' + uniqueId();
    return _this;
  }

  createClass(Textarea, [{
    key: 'render',
    value: function render() {
      var context = this.context,
          id = this.id;
      var _props = this.props,
          _ref = _props._ref,
          placeholder = _props.placeholder,
          stylePlaceholder = _props.stylePlaceholder,
          styleHover = _props.styleHover,
          styleFocus = _props.styleFocus,
          styleDisabled = _props.styleDisabled,
          text = _props.text,
          rest = objectWithoutProperties(_props, ['_ref', 'placeholder', 'stylePlaceholder', 'styleHover', 'styleFocus', 'styleDisabled', 'text']);


      var inlineStyle = [];
      if (stylePlaceholder) {
        PLACEHOLDER_PREFIXES$1.forEach(function (prefix) {
          inlineStyle.push('#' + id + prefix + ' {' + toCSS(stylePlaceholder) + '}');
        });
      }
      if (styleHover) {
        inlineStyle.push(inlineStyle + ' #' + id + ':hover {' + toCSS(styleHover) + '}');
      }
      if (styleFocus) {
        inlineStyle.push('#' + id + ':focus {' + toCSS(styleFocus) + '}');
      }
      if (styleDisabled) {
        inlineStyle.push('#' + id + ':disabled {' + toCSS(styleDisabled) + '}');
      }
      // TODO remove when we normalise this
      if (!rest.value) {
        rest.defaultValue = text;
      }

      return React__default.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName$10,
            lineNumber: 54
          },
          __self: this
        },
        React__default.createElement(
          'style',
          {
            __source: {
              fileName: _jsxFileName$10,
              lineNumber: 55
            },
            __self: this
          },
          inlineStyle.join('\n')
        ),
        React__default.createElement('textarea', _extends({}, rest, {
          id: id,
          ref: _ref,
          placeholder: placeholder ? context.i18n ? context.i18n.t(placeholder) : placeholder : undefined,
          __source: {
            fileName: _jsxFileName$10,
            lineNumber: 57
          },
          __self: this
        }))
      );
    }
  }]);
  return Textarea;
}(React.Component);

Textarea.defaultProps = {
  style: {},
  styleDisabled: {},
  styleFocus: {},
  stylePlaceholder: {},
  text: ''
};

Textarea.contextTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired
  })
};

var _Vertical = createGroup('Vertical', { flexDirection: 'column' });

var _jsxFileName$11 = '/Users/buckleyn/Projects/panels/blocks/circle.js';
var _this$4 = undefined;
var Circle = function Circle(props) {
  return React__default.createElement('circle', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$11,
      lineNumber: 3
    },
    __self: _this$4
  }));
};

var _jsxFileName$12 = '/Users/buckleyn/Projects/panels/blocks/clip-path.js';
var _this$5 = undefined;
var ClipPath = function ClipPath(props) {
  return React__default.createElement('clip-path', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$12,
      lineNumber: 3
    },
    __self: _this$5
  }));
};

var _jsxFileName$13 = '/Users/buckleyn/Projects/panels/blocks/ellipse.js';
var _this$6 = undefined;
var Ellipse = function Ellipse(props) {
  return React__default.createElement('ellipse', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 3
    },
    __self: _this$6
  }));
};

var _jsxFileName$14 = '/Users/buckleyn/Projects/panels/blocks/g.js';
var _this$7 = undefined;
var G = function G(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties(_ref, ['children']);
  return React__default.createElement(
    'g',
    _extends({}, props, {
      __source: {
        fileName: _jsxFileName$14,
        lineNumber: 4
      },
      __self: _this$7
    }),
    children
  );
};

var _jsxFileName$15 = '/Users/buckleyn/Projects/panels/blocks/line.js';
var _this$8 = undefined;
var Line = function Line(props) {
  return React__default.createElement('line', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$15,
      lineNumber: 3
    },
    __self: _this$8
  }));
};

var _jsxFileName$16 = '/Users/buckleyn/Projects/panels/blocks/rect.js';
var _this$9 = undefined;
var Rect = function Rect(props) {
  return React__default.createElement('rect', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$16,
      lineNumber: 3
    },
    __self: _this$9
  }));
};

var _jsxFileName$17 = '/Users/buckleyn/Projects/panels/blocks/svg.js';
var _this$10 = undefined;
var Svg = function Svg(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties(_ref, ['children']);
  return React__default.createElement(
    'svg',
    _extends({ focusable: props.focusable || false }, props, {
      __source: {
        fileName: _jsxFileName$17,
        lineNumber: 4
      },
      __self: _this$10
    }),
    children
  );
};

var _jsxFileName$18 = '/Users/buckleyn/Projects/panels/blocks/path.js';
var _this$11 = undefined;
var Path = function Path(props) {
  return React__default.createElement('path', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$18,
      lineNumber: 3
    },
    __self: _this$11
  }));
};

var _jsxFileName$19 = '/Users/buckleyn/Projects/panels/blocks/polygon.js';
var _this$12 = undefined;
var Polygon = function Polygon(props) {
  return React__default.createElement('polygon', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$19,
      lineNumber: 3
    },
    __self: _this$12
  }));
};

var _jsxFileName$20 = '/Users/buckleyn/Projects/panels/blocks/polyline.js';
var _this$13 = undefined;
var Polyline = function Polyline(props) {
  return React__default.createElement('polyline', _extends({}, props, {
    __source: {
      fileName: _jsxFileName$20,
      lineNumber: 3
    },
    __self: _this$13
  }));
};

exports.DangerouslySetInnerHTML = DangerouslySetInnerHTML;
exports.Font = Font;
exports.Horizontal = Horizontal;
exports.Image = Image;
exports.Input = Input;
exports.Knocking = Knocking;
exports.List = List;
exports.Style = Style;
exports.Text = Text;
exports.Textarea = Textarea;
exports.Vertical = _Vertical;
exports.Circle = Circle;
exports.ClipPath = ClipPath;
exports.Ellipse = Ellipse;
exports.G = G;
exports.Line = Line;
exports.Rect = Rect;
exports.Svg = Svg;
exports.Path = Path;
exports.Polygon = Polygon;
exports.Polyline = Polyline;